<nav>
    <a href=""><p>Login</p></a>
    <img src="../../../assets/icons/TOP_MENU.png" alt="menu hamburguesa">
</nav>